import { useEffect, useState } from "react";
import EmailListContext from "../context/emailListContext";

const EmailListProvider = ({ children }) => {
  const [emails, setEmails] = useState([]);

  return (
    <EmailListContext.Provider value={{emails, setEmails}}>
      {children}
    </EmailListContext.Provider>
  );
};


export default EmailListProvider;